import { render, staticRenderFns } from "./List.vue?vue&type=template&id=675f4988&scoped=true&"
import script from "./List.vue?vue&type=script&lang=ts&"
export * from "./List.vue?vue&type=script&lang=ts&"
import style1 from "./List.vue?vue&type=style&index=1&id=675f4988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f4988",
  null
  
)

export default component.exports